import CardLink from './CardLink.js';

export default CardLink;
